import { Text, Tooltip, TextButton } from "@amzn/storm-ui";

export interface SharePitchedContentButtonProps {
    handleClick: () => void;
    disabled: boolean;
}

export const SharePitchedContentButton = (
    props: SharePitchedContentButtonProps,
): JSX.Element => {
    const { handleClick, disabled } = props;

    const SHARE_BUTTON_LABEL = "Share deck";
    const SHARE_BUTTON_TOOLTIP = (
        <>
            <Text>
                We do not support External Sharing of Video (e.g. .mov, .mp4),
                Image (e.g. .png, .jpg, .jpeg, .svg) and Audio (e.g. .aac) at
                this time.
            </Text>
            <br />
            <Text>
                You can only share PowerPoint (.ppt, .pptx, .potx, .pptm), Excel
                (.xls, .xlsx), Word (.doc, .docx) and PDF (.pdf) files
                externally at this time.
            </Text>
        </>
    );

    return (
        <>
            {disabled ? (
                <Tooltip
                    data-testid="share-deck-disabled-tooltip"
                    nonInteractive
                    trigger={
                        <div>
                            <TextButton
                                id="disabled-share-deck-button"
                                data-testid="disabled-share-deck-button"
                                disabled
                                style={{ pointerEvents: "none" }}
                            >
                                {SHARE_BUTTON_LABEL}
                            </TextButton>
                        </div>
                    }
                >
                    {SHARE_BUTTON_TOOLTIP}
                </Tooltip>
            ) : (
                <TextButton
                    id="share-deck-button"
                    data-testid="share-deck-button"
                    onClick={handleClick}
                >
                    {SHARE_BUTTON_LABEL}
                </TextButton>
            )}
        </>
    );
};
